import { render } from "./CartHeader.vue?vue&type=template&id=4cd52e10"
import script from "./CartHeader.vue?vue&type=script&lang=js"
export * from "./CartHeader.vue?vue&type=script&lang=js"

import "./CartHeader.vue?vue&type=style&index=0&id=4cd52e10&lang=css"
script.render = render

export default script